import {cn} from "../../../lib/utils";

interface Props {
    spacing?: "default" | "compact";
    className?: string;
    cols?: 1 | 2;
}

export function ItemsList (props: React.PropsWithChildren<Props>) {
    const cls = cn(
        "grid grid-cols-1 max-w-[85svw]",
        props.spacing === "compact" ? "gap-16" : "gap-24",
        props.cols === 2 && "md:grid-cols-2 gap-x-6",
        props.className,
    );
    return <div className={cls}>
        { props.children }
    </div>
}